import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import MuiTab from '@material-ui/core/Tab';
import styled from 'styled-components';

const StyledTab = styled(MuiTab)`
  &&& {
    textTransform: none;
    min-width: 32px;
    min-height: 48px;
    font-weight: 400;
    margin-right: .125rem;

    &:hover {
      color: #40a9ff;
      opacity: 1;
    }

    &:selected {
      color: #343434;
      font-weight: 700;
    }

    &:focus {
      color: #00b33b;
    }
  }
`;

const Tab = ({
  matchPhone,
  index,
  keyValue,
  handleChange
}) => {
  const handleChangeHandler = useCallback(
    e => {
      handleChange(e, index);
    },
    [index],
  );

  return (
    <StyledTab
      id={`itinerary-tab-${index}`}
      aria-controls={`itinerary-tabpanel-${index}`}
      label={`${matchPhone ? 'D' : 'Day'}${index + 1}`}
      key={keyValue}
      onClick={handleChangeHandler}
    />
  );
};

Tab.propTypes = {
  matchPhone: PropTypes.bool,
  index: PropTypes.number,
  keyValue: PropTypes.string,
  handleChange: PropTypes.func,
};

Tab.defaultProps = {
  matchPhone: false,
  keyValue: '',
  index: 0,
  handleChange: () => {},
};

export default Tab;
